import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

function getTextForLanguage(globalInfoText: string, language: string): string {
  let texts: Record<string, string>;
  try {
    texts = JSON.parse(globalInfoText || "{}");
  } catch {
    return "";
  }
  if (!texts) {
    return "";
  }
  return texts[language] || texts[language.split("-")[0]] || "";
}

function GlobalInfoBox(
  { globalInfoText }: { globalInfoText: string } = { globalInfoText: "" }
) {
  const { t, i18n } = useTranslation("common");
  const language = i18n.resolvedLanguage ?? i18n.language ?? "";
  const currentText = getTextForLanguage(globalInfoText, language);
  return (
    <>
      {currentText && (
        <Alert variant="warning" style={{ borderRadius: 0, marginBottom: 0 }}>
          <div style={{ maxWidth: "800px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>{t("alert.notice")}</p>
            <p style={{ marginBottom: 0 }}>{currentText}</p>
          </div>
        </Alert>
      )}
    </>
  );
}

export default GlobalInfoBox;
